import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as agentInfoVerificationsActions from '../agent-info-verification/redux/actions';
import { Redirect } from 'react-router-dom';
import { FieldRow } from 'common';
import * as actions from '../common/redux/actions';

export class Login extends Component {
	state = {
		username: "",
		password: "",
		redirectRoute: null,
		verificationEnabled: false,
		user: {},
		supervisorVerificationRequired: true,
	}

	componentDidMount = () => this.props.actions.logoutAction();

	componentDidUpdate = async (prevProps) => {
		const {
			props: {
				agentInfoVerification: {
					showAgentVerificationForm,
					lockedOutVerificationSent,
					lockedOutShowAgentVerificationForm,
					agentInfoVerificationSubmitted,
					agentVerificationInfo,
					verificationLocationEnabled
				},
				common: { user, isSupervisor }
			},
			state: { verificationEnabled }
		} = this;

		if(user && verificationLocationEnabled !== prevProps.verificationLocationEnabled && verificationLocationEnabled !== undefined && agentVerificationInfo && Object.keys(agentVerificationInfo).length > 0 && !verificationEnabled) {
			let redirectRoute = 'Schedules';
			
			if (!isSupervisor && verificationLocationEnabled && !agentVerificationInfo.isVerified) {
				if (lockedOutVerificationSent) redirectRoute = 'AgentLockedOutConfirmation';
				else if ((lockedOutShowAgentVerificationForm) || (showAgentVerificationForm && !agentInfoVerificationSubmitted)) {
					redirectRoute = 'AgentInfoVerification';
				}
			}
			
			this.setState({ redirectRoute, verificationEnabled: true })
		}
	}

	onInputChange = (field, e) => {
		let stateObj = this.state;
		stateObj[field] = e.target.value;
		this.setState(stateObj);
	}

	handleLogin = (e) => {
		const {
			props: { actions: { loginAction } },
			state: { username, password }
		} = this;

		e.preventDefault();
		if (loginAction)
			loginAction({ 
				Username: username, 
				Password: password
			});
	}

	render() {
		const {
			props: { isLoggedIn },
			state: { redirectRoute, verificationEnabled }
		} = this;
		
		return (
			<div className="login-page">
				{ isLoggedIn && verificationEnabled && redirectRoute !== null &&
					<Redirect to={{ pathname: redirectRoute }} />
				}
				<div>
					<div className="logo large"></div>
					<div className="divider"></div>
					<div className="title">Agent Portal</div>

					<form className="login-box" onSubmit={this.handleLogin}>	
						<span className="error">{ this.props.error }</span>
						<FieldRow>
							<span className="sp-portal user-icon"></span>
							<input 
								className="login-input"
								placeholder="Username"
								type="text" 
								autoComplete="username"
								maxLength="80"
								onChange={(e) => this.onInputChange("username", e)}
								/>
						</FieldRow>
						<FieldRow>
							<span className="sp-portal lock-icon"></span>
							<input 
								className="login-input"
								placeholder="Password"
								type="password" 
								autoComplete="current-password"
								maxLength="80"
								onChange={(e) => this.onInputChange("password", e)}
								/>
						</FieldRow>
						<input type="submit" value="Log In">
						</input>
					</form>
				</div>
			</div>
		);
	}
}


const mapStateToProps = ({
	common: {
		loginError: error,
		isLoggedIn,
	},
	common,
	agentInfoVerification
}) => {
	return {
		error,
		isLoggedIn,
		common,
		agentInfoVerification
	};
}

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({ actions: bindActionCreators({ ...actions, ...agentInfoVerificationsActions }, dispatch) })

export default connect(mapStateToProps, mapDispatchToProps)(Login);


// WEBPACK FOOTER //
// ./src/features/login/Login.js